// exported selectors used with the useSelector hook

export const selectTheme = (state) => state.theme
export const selectToken = (state) => state.token
export const selectUser = (state) => state.userStats